<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.433 8.563V.864A.855.855 0 0 0 8.577.01H.878a.855.855 0 0 0-.855.855v7.7c0 .471.383.855.855.855h7.7a.856.856 0 0 0 .855-.856Zm-1.711 0H1.734a.856.856 0 0 1-.856-.855V1.72c0-.473.383-.856.856-.856h5.988c.472 0 .855.383.855.856v5.988a.856.856 0 0 1-.855.855Zm3.421-5.988h-.855v.856c.472 0 .855.383.855.855v5.988a.856.856 0 0 1-.855.856H4.3a.856.856 0 0 1-.855-.856h-.856v.856c0 .472.383.855.856.855h7.698A.856.856 0 0 0 12 11.13v-7.7a.856.856 0 0 0-.856-.855Z"
      fill="#79789A"
    />
  </svg>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
@Component
export default class CopyIcon extends Vue {}
</script>
